import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { Reason } from "../Export/AssetPandaExport";

export class HaloExport implements ObjectSerializer {
	public static readonly pdfName: string = 'PDF';
	public static readonly svgName: string = 'SVG';
	public static readonly vdxName: string = 'Visio (vdx)';
	public static readonly vsdxName: string = 'Visio (vsdx)';
	public static mapFormatDropdownOptions: string[] = [this.vdxName, this.vsdxName, this.pdfName, this.svgName];

	public EnableExport: boolean;

	public TargetServerApiURL: string;
	public TargetServerClientID: string;
	public TargetServerUsername: string;
	public TargetServerPassword: string;
	public UseMacAddressLookup: boolean;
	public UseIpAddressLookup: boolean;
	public ClientName: string;
	public SiteName: string;

	public ExportOrigin: string;

	public ExportDevices: boolean;
	public ExportConfigs: boolean;
	public ExportDependencies: boolean;
	public ExportPasswords: boolean;

	public ExportMapToNetwork: boolean;
	public MapFilename: string;
	public MapFileExtension: string;

	public get HasTargetServerApiURL(): boolean {
		return !!this.TargetServerApiURL;
	}

	public get HasTargetServerClientID(): boolean {
		return !!this.TargetServerClientID;
	}

	public get HasTargetServerUsername(): boolean {
		return !!this.TargetServerUsername;
	}

	public get HasTargetServerPassword(): boolean {
		return !!this.TargetServerPassword;
	}

	public get HasClientName(): boolean {
		return !!this.ClientName;
	}

	public get HasSiteName(): boolean {
		return !!this.SiteName;
	}

	public get HasExportOrigin(): boolean {
		return !!this.ExportOrigin;
	}

	public get HasMapFilename(): boolean {
		return !!this.MapFilename;
	}

	public get HasMapFileExtension(): boolean {
		return !!this.MapFileExtension;
	}

	constructor() {
		this.Clear();
	}

	public Copy(other: HaloExport): void {
		this.Clear();

		this.EnableExport = other.EnableExport;

		this.TargetServerApiURL = other.TargetServerApiURL;
		this.TargetServerClientID = other.TargetServerClientID;
		this.TargetServerUsername = other.TargetServerUsername;
		this.TargetServerPassword = other.TargetServerPassword;
		this.UseMacAddressLookup = other.UseMacAddressLookup;
		this.UseIpAddressLookup = other.UseIpAddressLookup;
		this.ClientName = other.ClientName;
		this.SiteName = other.SiteName;

		this.ExportOrigin = other.ExportOrigin;

		this.ExportDevices = other.ExportDevices;
		this.ExportConfigs = other.ExportConfigs;
		this.ExportDependencies = other.ExportDependencies;
		this.ExportPasswords = other.ExportPasswords;

		this.ExportMapToNetwork = other.ExportMapToNetwork;
		this.MapFilename = other.MapFilename;
		this.MapFileExtension = other.MapFileExtension;
	}

	public Clear(): void {
		this.EnableExport = false;

		this.TargetServerApiURL = "";
		this.TargetServerClientID = "";
		this.TargetServerUsername = "";
		this.TargetServerPassword = "";
		this.UseMacAddressLookup = false;
		this.UseIpAddressLookup = false;
		this.ClientName = "";
		this.SiteName = "";

		this.ExportOrigin = "agent";

		this.ExportDevices = false;
		this.ExportConfigs = false;
		this.ExportDependencies = false;
		this.ExportPasswords = false;

		this.ExportMapToNetwork = false;
		this.MapFilename = "";
		this.MapFileExtension = "";
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (!(obj instanceof HaloExport))
			return false;
		var other = (obj as HaloExport);

		return (
			this.EnableExport == other.EnableExport &&

			this.TargetServerApiURL == other.TargetServerApiURL &&
			this.TargetServerClientID == other.TargetServerClientID &&
			this.TargetServerUsername == other.TargetServerUsername &&
			this.TargetServerPassword == other.TargetServerPassword &&
			this.UseMacAddressLookup == other.UseMacAddressLookup &&
			this.UseIpAddressLookup == other.UseIpAddressLookup &&
			this.ClientName == other.ClientName &&
			this.SiteName == other.SiteName &&

			this.ExportOrigin == other.ExportOrigin &&

			this.ExportDevices == other.ExportDevices &&
			this.ExportConfigs == other.ExportConfigs &&
			this.ExportDependencies == other.ExportDependencies &&
			this.ExportPasswords == other.ExportPasswords &&

			this.ExportMapToNetwork == other.ExportMapToNetwork &&
			this.MapFilename == other.MapFilename &&
			this.MapFileExtension == other.MapFileExtension);
	}

	public IsValid(reason: Reason): boolean {
		reason.Value = "";

		if (this.EnableExport) {
			if (!this.HasTargetServerApiURL) {
				reason.Value = "The Halo Server/API URL must be specified";
				return false;
			}
			if (!this.HasTargetServerClientID) {
				reason.Value = "The Halo Server/ client ID must be specified";
				return false;
			}
			if (!this.HasTargetServerUsername) {
				reason.Value = "The Halo API username must be specified";
				return false;
			}
			if (!this.HasTargetServerPassword) {
				reason.Value = "The Halo API password must be specified";
				return false;
			}
			if (!this.HasClientName) {
				reason.Value = "A Halo company name must be specified";
				return false;
			}

			return true;
		}
		else {
			return true;
		}
	}

	public Write(obj: any, context: any): void {
		obj.halo_export = {};
		obj = obj.halo_export;

		obj.enable_export = ValueEncoder.EncodeBoolean(this.EnableExport);

		if (this.HasTargetServerApiURL)
			obj.target_server_api_url = this.TargetServerApiURL;
		if (this.HasTargetServerClientID)
			obj.target_server_client_id = this.TargetServerClientID;
		if (this.HasTargetServerUsername)
			obj.target_server_username = this.TargetServerUsername;
		if (this.HasTargetServerPassword)
			obj.target_server_password = this.TargetServerPassword;
		obj.use_mac_lookup = ValueEncoder.EncodeBoolean(this.UseMacAddressLookup);
		obj.use_ip_lookup = ValueEncoder.EncodeBoolean(this.UseIpAddressLookup);

		if (this.HasClientName)
			obj.client_name = this.ClientName;
		if (this.HasSiteName)
			obj.site_name = this.SiteName;

		if (this.HasExportOrigin)
			obj.export_origin = this.ExportOrigin;

		obj.export_devices = ValueEncoder.EncodeBoolean(this.ExportDevices);
		obj.export_configs = ValueEncoder.EncodeBoolean(this.ExportConfigs);
		obj.export_dependencies = ValueEncoder.EncodeBoolean(this.ExportDependencies);

		obj.export_map_to_network = ValueEncoder.EncodeBoolean(this.ExportMapToNetwork);
		if (this.HasMapFilename)
			obj.map_file_name = this.MapFilename;
		if (this.HasMapFileExtension)
			obj.map_file_ext = this.MapFileExtension;
	}

	public Read(obj: any, context: any): void {
		this.Clear();

		if (!obj.halo_export)
			throw new Error();
		obj = obj.halo_export;

		if (obj.enable_export !== undefined)
			this.EnableExport = ValueEncoder.DecodeBoolean(obj.enable_export);

		if (obj.target_server_api_url !== undefined)
			this.TargetServerApiURL = obj.target_server_api_url;
		if (obj.target_server_client_id !== undefined)
			this.TargetServerClientID = obj.target_server_client_id;
		if (obj.target_server_username !== undefined)
			this.TargetServerUsername = obj.target_server_username;
		if (obj.target_server_password !== undefined)
			this.TargetServerPassword = obj.target_server_password;
		if (obj.use_mac_lookup !== undefined)
			this.UseMacAddressLookup = ValueEncoder.DecodeBoolean(obj.use_mac_lookup);
		if (obj.use_ip_lookup !== undefined)
			this.UseIpAddressLookup = ValueEncoder.DecodeBoolean(obj.use_ip_lookup);
		if (obj.client_name !== undefined)
			this.ClientName = obj.client_name;
		if (obj.site_name !== undefined)
			this.SiteName = obj.site_name;

		if (obj.export_origin !== undefined)
			this.ExportOrigin = obj.export_origin;

		if (obj.export_devices !== undefined)
			this.ExportDevices = ValueEncoder.DecodeBoolean(obj.export_devices);
		if (obj.export_configs !== undefined)
			this.ExportConfigs = ValueEncoder.DecodeBoolean(obj.export_configs);
		if (obj.export_dependencies !== undefined)
			this.ExportDependencies = ValueEncoder.DecodeBoolean(obj.export_dependencies);
		if (obj.export_passwords !== undefined)
			this.ExportPasswords = ValueEncoder.DecodeBoolean(obj.export_passwords);

		if (obj.export_map_to_network !== undefined)
			this.ExportMapToNetwork = ValueEncoder.DecodeBoolean(obj.export_map_to_network);
		if (obj.map_file_name !== undefined)
			this.MapFilename = obj.map_file_name;
		if (obj.map_file_ext !== undefined)
			this.MapFileExtension = obj.map_file_ext;
	}

}